import {
  DataLayerEvent,
  DataLayerFormName,
  DataLayerFormStage,
  FormFieldName,
} from '../../../../../../common/utilities/customDatalayerInterface';
import digitalDataAssignment from '../../../../../../common/utilities/digitalDataAssignment';
import dataLayerToggleVerification from '../../../../../../common/utilities/dataLayerToggleVerification';
import { GetSimpleSpecPackTrimLevel_specPacks } from '../../../../trimLevels/graphql/queries/__generated__/GetSimpleSpecPackTrimLevel';
import IDimensions from '../../../../gqlCommon/model/IDimensions';

interface SpeckPackDataLayerArgs {
  specPacks: GetSimpleSpecPackTrimLevel_specPacks[];
  value: string;
  dimension: IDimensions;
}

const SpeckPackDataLayer = ({ specPacks, value, dimension }: SpeckPackDataLayerArgs): void => {
  try {
    const isDataLayer = dataLayerToggleVerification(dimension);
    if (isDataLayer) {
      const selectedSpeckPack: GetSimpleSpecPackTrimLevel_specPacks = specPacks.find(
        item => item.specPack.attributes.oemcode === value,
      );
      if (Object.keys(selectedSpeckPack).length > 0) {
        digitalDataAssignment({
          event: DataLayerEvent.FORM_INTERACT,
          form: {
            name: DataLayerFormName.CONFIGURATOR,
            stage: DataLayerFormStage.CONFIGURE_CAR,
            field: {
              name: FormFieldName.SPECKPACK,
              value: selectedSpeckPack.specPack.attributes.shortname,
            },
          },
        });
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('DataLayer error', err);
  }
};

export default SpeckPackDataLayer;
